<template>
  <div class="custom-text" :class="{ 'custom-text--feeling-lucky': feelingLucky}">
    <form class="text-form" action @submit="applyText">
      <div
        v-if="showTextInput"
        class="custom-text__wrapper"
        :class="{ 'custom-text__wrapper--feeling-lucky': feelingLucky}"
      >
        <label for="customText" class="sr-only">Enter your text</label>
        <!-- <div class="custom-text__input-wrap"> -->
        <input
          :maxlength="characterLimit"
          v-model="inputText"
          :placeholder="defaultText"
          name="customText"
          id="customText"
          autocomplete="off"
          v-on:keyup.13="applyText"
          @blur="applyIfEmpty"
          class="custom-text__input"
          :class="{'custom-text__input--feeling-lucky': feelingLucky, 'custom-text__input--error': error }"
        >
        <button
          :disabled="!textDifferent"
          @click="applyText"
          type="button"
          class="custom-text__btn"
        >Apply</button>
        <div class="custom-text__action">
          <p
            class="custom-text__left"
            :class="{ 'custom-text__left--different': textDifferent && !feelingLucky}"
          >
            Characters left: {{ charactersLeft }}
            <span
              class="custom-text__error"
              v-if="error"
            >KEEP IT CLASSY. Being ultimate means being cool. Any orders featuring text that contains profanity, insulting or discriminatory content, content construed to incite violence, or content we don’t want associated with our insanely awesome products will be rejected.</span>
          </p>
          <button
            @click="applyText"
            v-if="!feelingLucky"
            class="custom-text__btn-mobile"
            :class="{'custom-text__btn-mobile--visible': textDifferent}"
          >Apply Text</button>
          <p
            class="custom-text__error custom-text__error--mobile"
            v-if="error"
          >KEEP IT CLASSY. Being ultimate means being cool. Any orders featuring text that contains profanity, insulting or discriminatory content, content construed to incite violence, or content we don’t want associated with our insanely awesome products will be rejected.</p>
        </div>
        <!-- </div> -->
        <p
          class="custom-text__desc"
          v-if="!feelingLucky"
        >Important dates. Your rap name. Your lover’s name. Add custom text here, or leave blank. Your text will be laser-etched into the speaker spine.</p>
      </div>
      <div class="btn-group btn-group--centered" v-if="feelingLucky && showApplyButtons">
        <button
          type="button"
          :disabled="inputText.trim() === '' || textDifferent"
          v-show="!textDifferent || inputText.trim() === '' || mediaQueryIs === 'desktop'"
          class="btn btn--inverse btn--right margin-bottom-sm btn--centered"
          @click="continueWithText"
          data-text="Continue with Text"
        >Continue with Text</button>
        <button
          type="button"
          v-show="(inputText.trim() !== '' && textDifferent ) && (mediaQueryIs === 'mobile' || mediaQueryIs === 'tablet')"
          class="btn btn--inverse btn--right margin-bottom-sm"
          @click="applyText"
          data-text="Apply Text"
        >Apply Text</button>
        <!-- TODO: clicking this specific button should trigger the popup modal, confirming that the user wants to move on without setting text -->
        <button
          class="btn btn--has-border btn--right btn--centered"
          @click="continueWithoutText"
          type="button"
          data-text="Continue without Text"
        >continue without text</button>
      </div>
      <!-- <Button v-if="feelingLucky" inverse direction="right" text="Go" to="/"/> -->
    </form>
  </div>
</template>

<script>
import store from "../../store";
import Button from "../Button.vue";
import * as EmojiStrip from "emoji-strip";
import { EventBus } from "../../eventBus";

export default {
  data() {
    return {
      characterLimit: 20,
      error: false,
      mediaQueryIs: null
    };
  },
  components: {
    Button
  },
  props: {
    feelingLucky: Boolean,
    showApplyButtons: {
      type: Boolean,
      default: true
    },
    showTextInput: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    const that = this;
    $(".text-form").submit(function(e) {
      e.preventDefault();
      document.activeElement.blur();
    });
    EventBus.$on("textError", error => {
      console.log("errorrrr", error);
      that.error = error;
    });
    mediaCheck({
      media: "(max-width: 767px)",
      entry: function() {
        that.mediaQueryIs = "mobile";
      }
    });
    mediaCheck({
      media: "(min-width: 768px) and (max-width: 991px)",
      entry: function() {
        that.mediaQueryIs = "tablet";
      }
    });
    mediaCheck({
      media: "(min-width: 992px)",
      entry: function() {
        that.mediaQueryIs = "desktop";
      }
    });
  },
  computed: {
    defaultText() {
      return store.state.defaultText;
    },
    inputText: {
      get() {
        const inputText = store.state.inputText;
        if (inputText) {
          return store.state.inputText;
        } else {
          return "";
        }
      },
      set(value) {
        store.commit("updateInputText", EmojiStrip(value.trim().toUpperCase()));
      }
    },
    textDifferent() {
      // TODO: we need to handle the ability to check if the user has touched the text field at all. if they HAVE, then even if it is empty we should be able to apply (as long as the customText value isn't already empty)
      if (this.inputText.trim() === "" && this.customText === null) {
        return false;
      }
      if (this.customText === null) {
        return true;
      }
      if (
        this.inputText.toUpperCase().trim() ===
        this.customText.toUpperCase().trim()
      ) {
        return false;
      }
      return true;
    },
    charactersLeft() {
      if (!this.inputText) {
        return this.characterLimit;
      } else {
        return this.characterLimit - this.inputText.length;
      }
    },
    customText: {
      get() {
        const customText = store.state.configuration.CustomText;
        return store.state.configuration.CustomText;
      },
      set(value) {
        store.commit("updateCustomText", EmojiStrip(value.toUpperCase()));
      }
    }
  },
  methods: {
    applyIfEmpty() {
      if (this.customText === null) {
        store.commit("updateCustomText", "");
      }
    },
    applyText(e) {
      if (e) {
        e.preventDefault();
      }

      document.activeElement.blur();
      const myText = EmojiStrip(this.inputText.trim().toUpperCase());
      const hasBadWord = store.state.forbiddenText.some(
        bad => myText.indexOf(bad) > -1
      );
      if (hasBadWord) {
        this.error = true;
      } else {
        this.error = false;
        store.commit("updateCustomText", myText);
      }
    },
    continueWithText() {
      this.applyText();
      if (!this.error) {
        this.$router.push({
          name: "completed-design"
        });
      }
    },
    continueWithoutText() {
      this.inputText = "";
      this.applyText();
      if (!this.error) {
        this.$router.push({
          name: "completed-design"
        });
      }
    },
    goToReview() {
      const that = this;
      this.$router.push({
        name: "completed-design"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables";

$font: "News Gothic", sans-serif;
.news-gothic {
  font-family: $font !important;
}
.noto {
  font-family: "Noto Sans", serif;
}
.margin-bottom-sm {
  margin-bottom: 0.6rem;
}
.custom-text {
  @media (min-width: 992px) {
    max-width: 900px;
    display: flex;
    margin-left: 1em;
    margin-right: 1em;
    margin-left: auto;
    margin-right: auto;
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    &--feeling-lucky {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &__error {
    color: red;
    display: block;
    text-transform: none;
    line-height: 1.2;
    margin-top: 0.5em;
    font-weight: normal;
    font-family: sans-serif;
    &--mobile {
      display: block;
      background: #f6f6f6;
      padding: 1em;
      margin: 0;
      @media (min-width: 992px) {
        display: none;
      }
    }
  }

  &__desc {
    display: none;
    @media (min-width: 992px) {
      font-family: sans-serif;
      text-align: left;
      font-size: 0.9em;
      line-height: 1.1;
      display: block;
      align-self: center;
      color: $greyDark;
      margin-left: 2em;
      max-width: 255px;
      grid-column-start: 3;
      grid-row-start: 1;
      margin-bottom: 0;
    }
  }
  &__action {
    @media (min-width: 992px) {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }
  &__left {
    text-transform: uppercase;
    color: $greyMidDark;
    font-weight: bold;
    font-size: 0.8em;
    margin-top: 0.5em;
    line-height: 1;
    @media (max-width: 991px) {
      padding-top: 1em;
      margin-top: 0;
      padding-bottom: 1em;
      .custom-text__error {
        display: none;
      }
    }
    &--different {
      display: none;
    }
    @media (min-width: 992px) {
      display: block;
    }
  }

  &__wrapper {
    @media (max-width: 991px) {
      background-color: $greyDark;
      color: $greyMid;
      min-height: 100px;
    }
    text-align: center;
    &--feeling-lucky {
      margin-bottom: 2.5em;
      @media (max-width: 991px) {
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
        background-color: transparent;
        color: $greyMid;
        margin-bottom: 0;
        span.custom-text__error {
          display: none;
        }
      }
    }
    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: auto 115px auto;
      grid-template-rows: 1fr auto;
    }
  }

  &__input-wrap {
    width: 100%;
  }

  &__input {
    color: #fff;
    text-transform: uppercase;
    border-radius: 0;
    background: #a3a3a3;
    border: none;
    font-weight: bold;
    font-size: 1.4em; // this is needed to fix 16 characters on a mobile device
    text-align: center;
    line-height: 2.5;
    padding-left: 1em;
    padding-right: 1em;
    border: none;
    margin-bottom: 0;
    box-sizing: border-box;
    max-width: 100%;
    width: 100%;
    font-family: $font, sans-serif;
    @media (max-width: 991px) {
      background-color: $greyDark;
    }
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &--feeling-lucky {
      font-size: 1.45em;
      @media (min-width: 992px) {
        font-size: 1.65em;
      }
    }
    &--error {
      border: 1px solid red;
    }
  }
  &__btn-mobile {
    display: none;
    background-color: $greyDark;
    color: #fff;
    font-family: $font;
    font-weight: bold;
    text-transform: uppercase;
    border: none;
    padding-top: 1em;
    padding-bottom: 1em;
    margin: 0;
    line-height: 1;
    font-size: 0.8em;
    &--visible {
      display: block;
      width: 100%;
    }

    @media (min-width: 992px) {
      display: none;
    }
  }
  &__btn {
    display: none;

    @media (min-width: 992px) {
      text-transform: uppercase;
      display: block;
      cursor: pointer;
      background: #000;
      border: none;
      color: #fff;
      font-family: $font;
      font-weight: bold;
      padding-left: 1.5em;
      padding-right: 1.5em;
      font-size: 0.9em;
      line-height: 1.75em;
      align-self: stretch;
      transition: background-color 0.25s;
      &[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
        &:hover {
          background-color: black;
        }
      }
      &:hover {
        background-color: $greyDark;
      }
    }
  }
}
.btn-group {
  @media (min-width: 601px) {
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
  .btn {
    @media (max-width: 991px) {
      width: 100%;
    }
    @media (min-width: 992px) {
      width: 240px;
      justify-content: center;
    }
  }
}

.text-form {
  width: 100%;
}
</style>